@let activeFiltersCount = activeFiltersCount$ | async;
<div class="py-5 flex-1">
  <div class="table-header table-header-offset table-header-with-controls">
    <div class="table-header-controls no-title">
      <div class="table-header-search">
        <rkt-table-search (changed)="onSearch($event)" placeholder="Search..."></rkt-table-search>
      </div>

      <div class="list-filters">
        <button type="button" appRemoveFocus class="table-header-filter-btn" (click)="filterMenu.toggle($event)" #filterBtn>
          <rkt-icon name="filter" class="table-header-filter-icon"></rkt-icon>
          Filter
          @if (activeFiltersCount) {
            <span class="table-header-filter-counter">{{ activeFiltersCount }}</span>
          }
        </button>
      </div>
    </div>
  </div>

  <div class="child-financial-account-list">
    <rkt-table
      [rows]="(financialAccounts$ | async) || []"
      [columns]="columns"
      [limit]="10"
      (fetchData)="getChildFinancialAccountList($event)"
      [count]="(totalElements$ | async)!"
      [loadingIndicator]="(isLoading$ | async)!"
      [offset]="activePage"
      [messages]="{ emptyMessage: 'No Financial Accounts found.' }"
      emptyValuePlaceholder="--"
      dateTimeFormat="MM/dd/yy HH:mm"
      [sortParam]="sortParams"
      (rowActivated)="router.navigate(['app', 'financial-accounts', $event.id])"
    ></rkt-table>
  </div>
</div>
<app-filter-menu
  #filterMenu
  [initialValues]="(activeFilters$ | async) || {}"
  [filters]="filters"
  (opened)="filterBtn.classList.add('opened')"
  (closed)="filterBtn.classList.remove('opened')"
  (saved)="applyFilters($event)"
>
</app-filter-menu>
